import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {getMomentsParamsList, editMomentsParams} from './service'

const model = createProjectModel({
    namespace: '，momentParams',
    state: {
        paramsConfig: null,
        selectedRowKeys: [],
    },
    effects: {
        *getTableList(xx, {select, put, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }

            const res = yield call(getMomentsParamsList, {params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })

            return res
        },

        *editMomentsParams({payload}, {call}) {
            return yield call(editMomentsParams, payload)
        },
    },

    reducers: {},
})

export default model
